"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeSnackbarStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeSnackbarStyles = function makeSnackbarStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: tokens.colors["fill-elevation-0"].rgb,
          backgroundImage: "none",
          boxShadow: tokens.effects["elevation-0-popover"].boxShadow,
          padding: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["3"]),
          minWidth: "320px",
          margin: "".concat(primitives.spacings["2"], " ").concat(primitives.spacings["2"], " ").concat(primitives.spacings["4"]),
          // Not addding theming for breakpoints; this is only to override the MUI default.
          "@media (min-width: 600px)": {
            minWidth: "320px"
          }
        },
        message: {
          display: "flex",
          alignItems: "center",
          padding: "".concat(primitives.spacings["0"], "px"),
          marginRight: primitives.spacings["6"],
          '& [class*="MuiSvgIcon-root"]': {
            marginRight: primitives.spacings["4"],
            fontSize: primitives.fontSizeFallbacks["4"]
          },
          '& > [class*="MuiTypography-root"]': {
            minWidth: "140px",
            maxWidth: "250px",
            '& [class*="MuiLink"]': {
              cursor: "pointer"
            }
          },
          '& > [class*="MuiContainer-root"]': {
            display: "flex",
            padding: "".concat(primitives.spacings["0"], "px"),
            '& [class*="MuiContainer-root"]': {
              minWidth: "140px",
              maxWidth: "250px",
              padding: "".concat(primitives.spacings["0"], "px"),
              '& [class*="MuiTypography-root"] + [class*="MuiTypography-root"]': {
                cursor: "pointer",
                marginTop: primitives.spacings["2"]
              }
            }
          }
        },
        action: {
          margin: "unset",
          padding: "unset",
          '& [class*="MuiSvgIcon-root"]': _objectSpread(_objectSpread({
            backgroundColor: tokens.colors["fill-elevation-0"].rgb,
            boxShadow: "none",
            cursor: "pointer",
            fontSize: primitives.fontSizeFallbacks["4"]
          }, tokens.transitions["state-blur"]), {}, {
            padding: "6px",
            borderRadius: primitives.borderRadii["medium"],
            "&:hover": _objectSpread({
              backgroundColor: tokens.colors["activated-fill-subtle"].rgb
            }, tokens.transitions["state-activate"]),
            "&:active": _objectSpread({
              backgroundColor: tokens.colors["activated-hover-fill-subtle"].rgb
            }, tokens.transitions["state-activate"]),
            "&:focus": {
              outline: "none"
            },
            "&:focus-visible": _objectSpread(_objectSpread({
              boxShadow: tokens.effects["focus-ring-thin"].boxShadow
            }, tokens.transitions["state-activate"]), {}, {
              "&:hover, &:active": {
                backgroundColor: tokens.colors["fill-elevation-0"].rgb
              }
            })
          }),
          '& [class*="MuiTypography-root"] [class*="MuiLink"]': {
            cursor: "pointer"
          },
          '& [class*="MuiTypography-root"] + [class*="MuiSvgIcon-root"]': {
            marginLeft: primitives.spacings["5"]
          }
        }
      }
    }
  };
};

exports.makeSnackbarStyles = makeSnackbarStyles;